import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CssBaseline from '@mui/material/CssBaseline';
import { CinchDialog } from '@cinch/ui';
export default function ChangedWorkingAsModal(props) {
  const {
    newCompany,
    oldCompany,
    onDone,
    onAccept,
    onBack
  } = props;
  return <>
      {!!newCompany && <CssBaseline />}
      <CinchDialog open={!!newCompany} actionSize="large" customWidth="400px" customHeight="auto" titleIcon={<ErrorOutlineIcon sx={{
      fontSize: 40,
      color: '#EF3C34'
    }} />} title="Company Mismatch" bodyData={<Box component="span">
            <Stack>
              <Stack sx={{
          py: 1
        }} direction="row" spacing={1}>
                <Typography component="span" sx={{
            color: '#1D252D'
          }}>
                  You are currently working as:{' '}
                </Typography>
                <Typography variant="tableHeader"> {oldCompany?.name} </Typography>
              </Stack>
              <Stack sx={{
          py: 1
        }} direction="row" spacing={1}>
                <Typography component="span" sx={{
            color: '#1D252D'
          }}>
                  You have tried to use a page that belongs to:{' '}
                </Typography>
                <Typography variant="tableHeader"> {newCompany?.name} </Typography>
              </Stack>
              <Stack sx={{
          py: 1
        }} direction="row">
                <Typography component="span" sx={{
            color: '#1D252D'
          }}>
                  If you want to switch to{' '}
                </Typography>
                <Typography sx={{
            px: '3px'
          }} variant="tableHeader">
                  {' '}
                  {newCompany?.name},{' '}
                </Typography>
                <Typography component="span" sx={{
            color: '#1D252D'
          }}>
                  {' '}
                  select Proceed{' '}
                </Typography>
              </Stack>
            </Stack>
          </Box>} cancelText="Go Back" onClose={() => {
      onBack();
      onDone();
    }} submitText="Proceed" onSubmit={() => {
      onAccept(newCompany);
      onDone();
    }} />
    </>;
}